<template>
    <div>
        <div class="example">
            <a-spin/>
        </div>
        <div style="margin-bottom: 10px">
            <a-skeleton active :paragraph="{rows:3,width:['90%','90%','50%']}" :title="false"/>
        </div>

    </div>

</template>

<script>
    export default {
        name: "spin"
    }
</script>

<style scoped lang="less">
    .example {
        text-align: center;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        padding: 50px;
        width: 100%;
        margin-bottom: 10px;
    }

    @media (max-width: 576px) {
        /*//<=768的设备   手机，paid */

    }

    @media (max-width: 992px) {

    }

    @media (min-width: 768px) {
        /*//>=768的设备   ipadpro */

    }

    @media (min-width: 992px) {
        /*//>=992的设备   小屏电脑*/

    }

    @media (min-width: 1200px) {
        /*//>=1200的设备   电脑*/
    }

    @media (min-width: 1600px) {
        /*//>=1200的设备  大屏电脑*/

    }

</style>
